import "./Buttons.css";

function Buttons() {
  return (
    <div className="container button-container">
   <a href="#footer" className=" cosmic-link">
   Redes sociales
</a>
    </div>
  );
}

export default Buttons;
// //Nuetros doc en drive:
// https://drive.google.com/file/d/1P9dMn0s5SnD69oMBqYQSS3g6c1wEz0T2/view?usp=sharing
// //Ejemplo compartido:
// https://drive.google.com/uc?export=download&id=14dEih51j5w4u187redk4OklUWRUITrP-


